export const projectSpecificResources = {
  tokenIcon: require('@project/assets/img/profile/icons/icon-token.svg'),
  iconChange: require('@project/assets/img/profile/icons/icon-change.svg'),
  iconChangeRed: require('@project/assets/img/profile/icons/icon-change-red.svg'),
  productTokensIcon: require('@project/assets/img/order/icon-coin.svg'),
  productPriceTokensIcon: require('@project/assets/img/order/icon-price-coin.svg'),
  deleteIcon: require('@/shared/assets/img/profile/icons/icon-delete.svg'),
  infoIcon: require('@/shared/assets/img/profile/icons/icon-delete.svg'),
  disabledInfoIcon: require('@/shared/assets/img/profile/icons/icon-info-disabled.svg'),
};
